import { Box } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipServiceProvisionCity = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.3 }}>
            <TooltipPopover>
                A cidade de prestação indica o local onde o serviço é fisicamente realizado.
                Escolha "Endereço do cliente" quando o serviço for executado presencialmente no município do tomador 
                (exemplo: obras, instalações técnicas, manutenção de equipamentos, etc).
                Em caso de dúvida, consulte seu contador.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipServiceProvisionCity;